/* Add address Jan 8, 2023 */
<template lang="pug">
	div(class="kt-settings-frm small")
		b-form(@submit="m_saveSetting"  class="p-2")
			//- General
			div(v-if="p_settingProps.key=='gen'" )
				div(class="form-group")
					label Header Tenant Name
					b-form-input(size="sm" v-model="d_data.tenantName" minlength=3 maxlength=50 style="width:300px")
					span(class="text-grey5") This is the name to displayed in the header panel
				div(class="form-group")
					label Header Logo
					kt-img-upld(:p_currentVal="c_tenantLogoURL" :p_size="{w:200, h:100}"
						@change="d_data.tenantLogoData_NEW = ($event||'delete');")
					span(class="text-grey5") Optional: Company logo or image displayed in the header panel
				div(class="form-group address")
					label Corporate Address
					kt-address(id="tenantAddress" :p_recData="c_data" :p_readOnly="p_mode=='view'")
				div(class="form-group")
					label Phone#
					b-form-input(size="sm" v-model="d_data.phone" minlength=3 maxlength=50 style="width:200px")
				div(class="form-group")
					label Website
					b-form-input(size="sm" v-model="d_data.website" minlength=3 maxlength=50 style="width:400px")
			
			//- Team Announcements
			div(v-if="p_settingProps.key == 'teamAnnc'" class="mb-3")
				div(class="annc-item-list pb-2")
					div(v-for="(item,ix) in d_data.teamAnnouncements" :key="ix" class="annc-item" )
						b-form-input(size="sm" v-model="item.date" type="date")
						b-form-textarea(size="sm" v-model="item.text" rows=2 placeholder="Enter Announcement Text")
						b-button(class="btn-remove-item" variant="none" title="Remove" @click="d_data.teamAnnouncements.splice(ix,1)")
							fa-icon(icon="times")

				b-button(class="btn-add-item" variant="outline-primary" title="Add" 
					@click="d_data.teamAnnouncements.unshift({date:d_util.fn_isoDtStr(), text:null})")
					fa-icon(icon="plus") 
					| Add
				span(class="text-grey5 pl-2") Click to add an announcement. Click "Save" when finished

			
			//- Decision Options
			div(v-else-if="p_settingProps.key=='decsOpt'")
				div(class="form-group")
					label Minimum % of max score for "Go"
					b-form-input(size="sm" v-model="d_data.minPctOfMaxForGo" type="number" min=0 max=100 step=0.01 style="width:100px")
					span(class="text-grey5") Enter a number between 0% and 100% to be used for suggesting a "Go" or "No Go" decision based on calculations from the bid factor questionnaire.
			div(class="pt-2")
				b-button(type="submit" variant="primary" ) Save
</template>

<script>
import util, {kbdpAlert, fn_humanizeLabel} from "@/utils/util.js";
import {refData, api_baseURL} from "@/utils/ref-data.js";
import {settings as api} from "@/utils/api.js";
export default {
	name: "kt-settings-frm",
	components: {
		'kt-img-upld': () => import("@/components/Ctrl/KT-ImgUpld.vue"),
		'kt-address': () => import("@/components/Ctrl/KT-Address.vue"),
	},
	created() {
			/*
			if(this.p_settingProps.key=='gen'){
				this.d_data=this.p_settingData;
				this.d_data.streetAddress=this.d_data?.streetAddress?this.d_data.streetAddress:null;
				this.d_data.city=this.d_data.city?this.d_data.city:null;
				this.d_data.stateProvince=this.d_data.stateProvince?this.d_data.stateProvince:null;
				this.d_data.zipCode=this.d_data.stateProvince?this.d_data.stateProvince:null;
				}
			*/
				
	},
	mounted() {},
	data() {
		return {
			d_util: util,
			d_refData: refData,
			d_data: {},
		};
	},
	props: {
		p_settingProps: Object,
		p_settingData: [Array, Object],
		p_refData: [Array, Object],
	},
	computed: {
		c_idKey() {
			return this.p_settingProps.context + 'Id';
		},
		c_label() {
			let sp = this.p_settingProps;
			return !sp ? null : sp.label || fn_humanizeLabel(sp.key);
		},
		c_tenantLogoURL() {
			return !this.d_data.tenantLogoURL ? null : api_baseURL + this.d_data.tenantLogoURL;
		},
		c_data(){return this.d_data;}

	},
	methods: {
		m_saveSetting(e) {
			e.preventDefault();
			let sp = this.p_settingProps;
			let settingData = null;

			if (sp.context == 'appTenantSetting') {

				if (sp.key == 'gen') {
					delete this.d_data.headerLogoData;
				}
				settingData = Object.keys(this.d_data).map(prop => ({
					prop, value: sp.key == 'teamAnnc' ? JSON.stringify(this.d_data[prop]) : this.d_data[prop]
				}));
			}
			let _this = this;


			kbdpAlert.showSaving(_this.c_label);
			api.fn_saveData(sp.context, sp.category, settingData).then((resp) => {

				if (resp.error || !resp.settingData) {
					let msg = `Unable to save ${_this.c_label} setting. ` + (resp.error || '');
					kbdpAlert.showErr(msg);
					return;
				}
				kbdpAlert.showOk(this.c_label + ' setting was saved successfully.');
			});
		}
	},
	watch: {
		p_settingData(val) {
			console.log('p_settingData');
			console.log(val);
			this.d_data = {};
			if (!val) return;

			if (this.p_settingProps.key == 'teamAnnc') {
				let valStr = val.teamAnnouncements || '[]';
				this.$set(this.d_data, 'teamAnnouncements', JSON.parse(valStr));
			}
			else {
				this.d_data = val;
			}

		

		},
		'p_settingProps.key'() {
			kbdpAlert.clear();
		}
	}
};



</script>

<style lang="less">
.kt-settings-frm {
	overflow-x: auto;

	form {
		input:invalid {
			border-color: #dc3545;
			box-shadow: none;
		}
	}

	.annc-item-list {
		div.annc-item {
			display: flex;
			// position: relative;
			padding: 0.5em 0;
			// width: 600px;
			max-width: 1200px;
			input[type="date"] {
				width: 150px;
				margin-right: 0.5em;
			}
			textarea {
				min-height: 100px;
				max-height: 400px;
				min-width: 600px;
				resize: both;
			}

			.btn-remove-item {
				opacity: 0.6;
				// font-size: 1.1em;
				background-color: #e9ecef;
				box-shadow: unset;
				color: #dc3545;
				padding: 0 0.4em;
				height: 100px;
				margin: auto 0;
				&:hover {
					opacity: unset;
				}
			}
		}
	}
	.btn-add-item {
		font-size: 1em;
		line-height: 1em;
		padding: 0.2em 0.3em;
		svg {
			font-size: 0.9em;
			margin-right: 0.2em;
		}
	}
.address{width:50%}
}
</style>